export enum Area {
  'sso' = 'sso',
  'customers' = 'customers',
  'email' = 'email',
  'sync' = 'sync',
  'rbac' = 'rbac',
  'apps' = 'apps',
  'summary' = 'summary',
}

export const Areas: { [key: string]: { name: string } } = {
  sso: { name: 'SSO + LOGIN' },
  customers: { name: 'CUSTOMERS' },
  email: { name: 'EMAIL' },
  sync: { name: 'SYNC' },
  rbac: { name: 'ROLES + ACCESS' },
  apps: { name: 'M365 APPS' },
  summary: { name: 'SUMMARY' },
}